/**
 * label
 * checked
 * disabled
 * onChange
 * hint
 * hintOptions - { maxWidth: number, contentStyle: object }
 *
 * slots:
 *   - label
 */

import { ViewModel as model } from './model';
import template from './template.html';
import './style';

import { registerComponent } from 'Utils/engine/register-component';

registerComponent('fc-switch', { model, template });
